import styled from "styled-components";
import { Button } from "../../atoms/Button";
import { CardTemplate } from "../../templates/CardTemplate";
import { useSmsSend } from "./hook";

export const SmsSendPage: React.FC = () => {
  const {
    maskedPhoneNumber,
    handleSmsSend,
    isRegistration,
    handleReSendEmail,
  } = useSmsSend();

  return (
    <CardTemplate title="SMS送信">
      <StyledDescriptionContainer>
        <StyledTextContainer>
          指定した電話番号をご確認してください。以下の番号にSMSで認証番号を送信します。番号が間違っている場合は、システム管理者に連絡してください。
        </StyledTextContainer>

        <StyledPhoneNumberContainer>
          <StyledTextContainer>電話番号</StyledTextContainer>

          <StyledPhoneNumberText>{maskedPhoneNumber}</StyledPhoneNumberText>
        </StyledPhoneNumberContainer>
      </StyledDescriptionContainer>

      <Button text="送信" variant="filled" onClick={handleSmsSend} fullWidth />
      {isRegistration && (
        <StyledReTelContainer>
          <Button
            text={"電話番号の再設定"}
            variant="link"
            onClick={handleReSendEmail}
          />
        </StyledReTelContainer>
      )}
    </CardTemplate>
  );
};

const StyledDescriptionContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
`;

const StyledTextContainer = styled.div`
  font-size: 14px;
  font-weight: 400;
  line-height: 150%;
`;

const StyledPhoneNumberContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 260px;
  height: 30px;
`;

const StyledPhoneNumberText = styled.div`
  font-size: 20px;
  font-weight: 400;
  line-height: 150%;
`;

const StyledReTelContainer = styled.div`
  display: flex;
  justify-content: center;
`;
